<!-- 销售订单数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo"
                                        ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey" :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 日期 -->
                                                <df-date v-if="formOneValue.fieldType == 'date'"
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)"
                                                    :isShowLong="false" :isdisabled="formOneValue.isChange == 0
                                                        || dataActionBox.actionType == 2
                                                        ">
                                                </df-date>

                                                <!-- 检索方案 -->
                                                <el-input v-else-if="formOneValue.fieldType == 'search'" clearable
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                    :disabled="formOneValue.isChange == 0

                                                        || dataActionBox.actionType == 2">
                                                    <el-button
                                                        @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                        slot="append" icon="el-icon-search"
                                                        :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                    </el-button>
                                                </el-input>
                                                <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                <el-select clearable size="mini"
                                                    v-else-if="formOneValue.entityField == 'cmIntype'"
                                                    @visible-change="selectChange" :disabled="formOneValue.isChange == 0

                                                        || dataActionBox.actionType == 2" @change="$forceUpdate()"
                                                    v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in lxList" :key="item.diName"
                                                        :label="item.diName" :value="item.diName">
                                                    </el-option>
                                                </el-select>
                                                <el-select clearable size="mini"
                                                    v-else-if="formOneValue.fieldType == 'formatter'"
                                                    @visible-change="selectChange" :disabled="formOneValue.isChange == 0

                                                        || dataActionBox.actionType == 2" @change="handleChange"
                                                    v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)"
                                                        :key="item.key" :label="item.key" :value="item.value">
                                                    </el-option>
                                                </el-select>
                                                <el-input
                                                    @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)"
                                                    v-else-if="formOneValue.fieldType == 'string' && formOneValue.entityField != 'scopeId'"
                                                    :disabled="formOneValue.isChange == 0

                                                        || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                    @blur="changeData(formOneValue.entityField)"
                                                    :maxlength="$store.state.inputLength"></el-input>
                                                <span v-else-if="formOneValue.entityField == 'scopeId'">
                                                    <el-select clearable size="mini" v-if="sendDataInfo.scopeType == 0"
                                                        v-model="sendDataInfo.scopeId" placeholder="请选择">
                                                        <el-option v-for="item in rangeObj.p" :key="item.discId"
                                                            :label="item.scopeName" :value="item.discId">
                                                        </el-option>
                                                    </el-select>
                                                    <el-select clearable size="mini" v-if="sendDataInfo.scopeType == 1"
                                                        v-model="sendDataInfo.scopeId" placeholder="请选择">
                                                        <el-option v-for="item in rangeObj.m" :key="item.discId"
                                                            :label="item.scopeName" :value="item.discId">
                                                        </el-option>
                                                    </el-select>
                                                    <el-select clearable size="mini" v-if="sendDataInfo.scopeType == 2"
                                                        v-model="sendDataInfo.scopeId" placeholder="请选择">
                                                        <el-option v-for="item in rangeObj.z" :key="item.discId"
                                                            :label="item.scopeName" :value="item.discId">
                                                        </el-option>
                                                    </el-select>
                                                </span>
                                                <el-input
                                                    @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)"
                                                    v-else :disabled="formOneValue.isChange == 0

                                                        || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'"
                                                v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey">
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{
                                                            $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                        }}
                                                    </span>
                                                </span>

                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>

                                            </el-form-item>

                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <div>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo',)"
                            v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 1">保存</el-button>
                    </div>
                    <div v-if="footForm">
                        <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                            <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                                <el-button type="success">{{ itemV.entityField == 'totalMoney' ?
                                    $common.getDecimalInfo(3, sendDataInfo[itemV.entityField])
                                    : sendDataInfo[itemV.entityField] }}</el-button>
                                <!-- <el-button type="success">{{ itemV.entityField == 'totalMoney' ? sendDataInfo[itemV.entityField].toFixed(2)
                : sendDataInfo[itemV.entityField] }}</el-button> -->
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <printPlan ref="printPlan"></printPlan>
        <operSelect ref="operSelect" @drawerCancel="drawerCancel" @conAdd="conAdd"></operSelect>
        <component :is="currentComponent" :ref="currentComponent"></component>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
    name: "desuLimitClassifyAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
    },
    data() {
        //这里存放数据
        return {
            lxList: [],
            currentComponent: "",
            historicalOrder: {
                cmName: "",
                cmId: "",
                bgmName: "",
                bgmId: "",
            },
            //--------------------
            showDialog: false,
            dialogList: [],
            focusIndex: "",
            dictionariesDatas: [], //配送方式
            detailRules: false, //规则
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                scopeType: 0
            },
            inputel: "", //所有input对象
            detaislDataInfo: {},
            showTabs: "",
            rangeObj: {},
            formDataList: [],
            dictionariesData: {},
            // userOneList:[],
            selectedDetailsIndex: 0,
            // 缺货登记
            stockRegisterBox: false,
            stockRegisterData: {
                bgmId: "",
                bgmName: "",
                cmId: "",
                cmName: "",
                wolrRegnumber: "",
                wolrRemark: "",
            },
            storageRoomList: [], //库房
            // 特价申请
            priceApplicationBox: false,
            priceApplicationData: {
                bgmId: "", //商品
                bgmName: "",
                coId: "", //货主
                coName: "",
                wosaSalecus: "",
                cmId: "",
                cmName: "",
                wosaAppprice: "", // 申请售价
                wosaAppreason: "", // 申请原因
                batchno: "", // 批号
                expidate: "", // 	有效期
                wosaEnddate: "", // 申请截止日期
                wosaMinprice: "", // 最低售价
                prodate: "", // 	生产日期
                acType: 0, // 0自动提交，1手动提交
            },
            editDateilsIndex: "",
            giftsList: [],
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            cmId: "",
            ormId: "",
            coId: 0,
            seType: "",
            setField: "",
            seIndex: 0,
            levleId: 0,
            seWidth: "0",
            mxHeight: 0,
            isLoaded: false,
            pageType: "one",
            parentSearchData: {
                orderType: 0, //	订单类型0.药品1.器械
            },
            selectedRow: [], // 当前已选择行
            mainFormList: [], //过滤的主表单
            tabForm: [], // tab循环的主表单
            mxForm: [],
            footForm: [],
            sField: "", // 赋值字段
            fField: "", //焦点字段
            nosField: "", // 不可赋值字段
            DialogExtract: false, //提取
            exId: "",
            exTitle: "",
            exWidth: "",
            ppId: "orderId",
            ticket: 0,
            nextSearch: false,
            rangeNum: 0
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        dealLabel(index) {
            if (index == 0) {
                return '生产范围'
            } else if (index == 1) {
                return "经营范围"
            } else {
                return "诊疗范围"

            }
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },
        handleChange() {
            this.sendDataInfo.scopeId = ''
            this.$forceUpdate()
        },
        changeData(data) {
            // this.sendDataInfo[data] = this.$common.getDecimalInfo(1, +this.sendDataInfo[data])
            // if (+this.sendDataInfo.dcNum > +this.sendDataInfo.ycNum) {
            //     this.sendDataInfo.dcNum = this.sendDataInfo.ycNum
            // }
        },
        // 输入框切换焦点
        nextFocus(index, fField) {
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
        },

        // 监听键盘事件
        keyUp(e) {
        },


        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },

        //换行提示
        lineMessageBox(data) {
            console.log(data)
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, nosField, setField) {
            setTimeout(() => {
                this.showDialog = false
            }, 16.7)
            if (type == "salesName" || type == "caiAddress" || type == "recName") {
                if (this.sendDataInfo.cmId == "") {
                    return this.$message({
                        message: "请先选择销售单位",
                        type: "warning",
                    });
                }
            }
            this.DialogVisible = true;
            removeEventListener("keyup", this.keyUp);
            this.seId = sId;
            this.seIndex = index;
            if (setField != undefined) {
                this.setField = setField;
            }
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            this.nosField = nosField;
            this.parentSearchData[type] = this.sendDataInfo[type];

        },

        // 不可赋值字段
        noSetField(val) {
            let arr = this.nosField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },

        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item];
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },

        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },
        //确认新增
        async sendDataAction(formName1) {
            let flag = false;
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
            if (+this.sendDataInfo.dcNum > +this.sendDataInfo.ycNum) {
                return this.$message({
                    message: "单次限销数量不可多于月次限销数量",
                    type: "error",
                });
            }
            let responseData
            // this.sendDataInfo.scopeId = this.sendDataInfo.scopeName
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.addGoodsscopeLimit(
                    this.sendDataInfo
                );
            } else if (this.dataActionBox.actionType == 1) {
                responseData = await this.$http.updateGoodsscopeLimit(
                    this.sendDataInfo
                );
            }
            if (responseData.status == 200) {
                this.$message.success(responseData.message)
                this.$emit("drawerCancel");
                this.init();
            } else {
                this.$message.error(responseData.message)
            }
        },
        drawerCancel() {
            this.$emit("drawerCancel", true);
        },
        conAdd() {

            this.init();
            // this.$refs["sendDataInfo"].resetFields();
            this.dataActionBox.actionType = 0;
        },
        //新增明细
        addDetail(sendDataInfo) {
        },


        //取消
        initActionBox(formName1, formName2) {
            this.$confirm(
                "确定取消" + this.dataActionBox.boxTitle + "吗?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    this.$emit("drawerCancel");
                    this.init();
                    this.$refs[formName1].resetFields();
                    this.$refs[formName2].resetFields();
                })
                .catch(() => { });
        },

        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }

        },
        initTime() {
            // this.getRequestData.start = this.$common.getStartTime()
            this.priceApplicationData.wosaEnddate = this.$common.getEndTime()
        },
        //上级流入
        openBox() {
            this.initTime()
            this.pageType = this.actionData.type;
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            this.showTabs = this.actionData.formData[0].jciName;
            var oldData = this.actionData.oldData;
            this.filterMainField();
            this.init();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.initDefaultValue();
            } else if (this.dataActionBox.actionType == 1) {
                this.cmId = oldData.cmId;
                this.ormId = oldData.ormId
                    ? oldData.ormId
                    : JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
                this.coId = oldData.coId;
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                for (const key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])
                }
                this.parentSearchData.cmId = oldData.cmId;
                console.log(this.parentSearchData.cmId);
                for (let key in this.sendDataInfo) {
                    if (this.sendDataInfo[key] == null) this.sendDataInfo[key] = "";
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            }
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform;
            arr.forEach((item) => {
                if (
                    item.defaultValue != "null" &&
                    item.defaultValue != null &&
                    item.defaultValue != ""
                ) {
                    this.sendDataInfo[item.entityField] = item.defaultValue;
                }
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1)
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var arr = []
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
        },
        getlxList() {
            this.$http.getCateDictionariesData({ ids: [38] }).then(res => {
                this.lxList = res.result
            })
        },
        async getQueryScopeByType(type) {
            let ormId = sessionStorage.getItem("ormId");
            let params = {
                type: type,
                ormId: ormId,
            };
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByType(params);
            if (responseData.status == 200) {
                return responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
            this.isLoaded = true;
        });
        this.getlxList()
        this.getQueryScopeByType(0).then((res) => {
            this.$set(this.rangeObj, "p", res);
        });
        this.getQueryScopeByType(1).then((res) => {
            this.$set(this.rangeObj, "m", res);
        });
        this.getQueryScopeByType(2).then((res) => {
            this.$set(this.rangeObj, "z", res);
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // addEventListener('keydown', this.keyDown)
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUp);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}</style>
<style>.el-table .rowStyle {
    background: #fff7ca !important;
}</style>